<template>
  <q-circular-progress
    v-if="showProgress"
    show-value
    font-size="10px"
    :value="value"
    size="40px"
    :thickness="0.3"
    color="white"
    track-color="white"
    class="Progress q-ma-md text-caps-3 text-neutral-5 my-12"
  >
    <p>{{ qntComEvidencia }}</p>

    <q-tooltip
      anchor="center right"
      self="center left"
      :offset="[10, 10]"
    >
      {{ value }}%
    </q-tooltip>
  </q-circular-progress>

  <div
    v-if="showNavigation && !loading"
    class="flex items-center gap-8 mr-24"
  >
    <OButton
      :disabled="disablePrev"
      primary
      class="!bg-white/30 !size-40 !p-0"
      icon="arrow_back"
      @click="emitPrev"
    />
    <OButton
      :disabled="disableNext"
      primary
      class="!bg-white/30 !size-40 !p-0"
      icon="arrow_forward"
      @click="emitNext"
    />
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import OButton from 'components/Button/OButton.vue'
import usePerguntas from 'composables/usePerguntas'

const props = defineProps({
  showProgress: Boolean,
  showNavigation: Boolean,
  evidencia: Object,
  alternativa: Object,
  loading: Object,
})

const emit = defineEmits(['click:change'])

const { alternativas, pergunta } = usePerguntas()

const currentAltIndex = ref(-1)

const listEvidences = computed(() => {
  return alternativas.value
    .filter((alt) => alt.tem_evidencia)
    .map((alt) => ({
      evidencia: alt.evidencia,
      pergunta: pergunta.value,
      alternativa: alt,
      alternativa_id: alt.id,
    }))
})

function setCurrentEvidenciaIndex() {
  const alternativaId = props.alternativa?.id
  let idx = currentAltIndex.value

  idx = listEvidences.value.findIndex(
    (e) => String(e.alternativa_id) === String(alternativaId)
  )

  currentAltIndex.value = idx
}

watch(
  [listEvidences, () => props.evidencia],
  setCurrentEvidenciaIndex,
  { immediate: true, deep: true }
)

const value = computed(() => {
  if (!alternativas.value?.length) return 0
  const temEvidencia = alternativas.value.filter(
    (a) => a.tem_evidencia
  )
  return Math.round(
    (temEvidencia.length / alternativas.value.length) * 100
  )
})

// Desabilitar anterior se for o primeiro ou não encontrado
const disablePrev = computed(() => {
  return currentAltIndex.value <= 0
})

// Desabilitar próximo se for o último ou não encontrado
const disableNext = computed(() => {
  const idx = currentAltIndex.value
  const total = listEvidences.value.length
  return idx === -1 || idx >= total - 1
})

function emitPrev() {
  const data = listEvidences.value.at(currentAltIndex.value - 1)
  currentAltIndex.value = currentAltIndex.value - 1
  emit('click:change', data)
}

function emitNext() {
  const data = listEvidences.value.at(currentAltIndex.value + 1)
  currentAltIndex.value = currentAltIndex.value + 1
  emit('click:change', data)
}

const qntComEvidencia = computed(() => {
  const temEvidencia = alternativas.value.filter(
    (a) => a.tem_evidencia
  ).length
  return `${temEvidencia}/${alternativas.value.length}`
})
</script>

<style lang="scss" scoped>
.Progress :deep(.q-circular-progress__track) {
  stroke: rgba(255, 255, 255, 0.2);
}
</style>
